module.exports = __webpack_public_path__ + "static/scale-model-of-fargo-air-museum-in-fargo-north-dakota-d9c72fbedb3ac515a126671bf852ab26.png";